module.exports = {
          srcSet: __webpack_public_path__ + "fa6167ecc273485a38bdff0aa4ea1ce0-154.png"+" 154w",
          images:[ {path: __webpack_public_path__ + "fa6167ecc273485a38bdff0aa4ea1ce0-154.png",width: 154,height: 55}],
          src: __webpack_public_path__ + "fa6167ecc273485a38bdff0aa4ea1ce0-154.png",
          toString:function(){return __webpack_public_path__ + "fa6167ecc273485a38bdff0aa4ea1ce0-154.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAcUlEQVR4nF3NsQ3CUBAD0GMDlJKSkiGooKKwe/bw0SRfQQkznrdB/4uK2s92FPJgZhg6GnoYUlGvgm6GpkJGz6OoMHUxNBu5GWqm1qK2glpBVyOjo9MvfJsDz4YWU0txwI+hc798GtrHIkeh/eG9oPsXgwdOn43HK+QAAAAASUVORK5CYII=",
          width: 154,
          height: 55
        }